import {
    createListenerMiddleware,
    isRejectedWithValue,
} from '@reduxjs/toolkit';

import { isFetchBaseQueryError } from '@/shared/api';

import { planMigrationActions } from '../slices/plan-migration.slice';
import type { MigrationStatusResponse } from '../types/plan-migration';

export const planMigrationListener = createListenerMiddleware();

const startPlanMigrationListener =
    planMigrationListener.startListening as TypedListening;

function isPlanMigrationError(payload: unknown): boolean {
    if (!isFetchBaseQueryError(payload)) {
        return false;
    }

    return (
        typeof payload.status === 'number' &&
        payload.status === 403 &&
        !!payload.data &&
        typeof payload.data === 'object' &&
        'error' in payload.data &&
        (payload.data as Record<string, unknown>)['error'] ===
            'plan_migration_required'
    );
}

startPlanMigrationListener({
    matcher: isRejectedWithValue,
    effect: (action, { dispatch }) => {
        if (isPlanMigrationError(action.payload)) {
            const { data } = action.payload as {
                data: {
                    migration_data: unknown;
                };
            };

            const migrationData =
                data.migration_data as MigrationStatusResponse;

            if (migrationData) {
                dispatch(planMigrationActions.showPopup(migrationData));
            }
        }
    },
});
